<div class="side-nav-account">
    <div *ngIf="authenticated">
        <span class="account-name fw-bold">{{recognitionName}}</span>&nbsp;
        <span class="account-name">({{customerId}})</span>
        <a *ngIf="showBaoying" class="switch-link" (click)="switchAccounts()" translate="cart.switch.accounts"></a>
    </div>
    <div *ngIf="!authenticated">
        <div class="no-account sponsor" *ngIf="!showBaoying && displaySponsorDetails">
            <span translate="cart.sponsor.text"></span>&nbsp;
            <span>{{sponsorName | limitToWithEllipse: 15}}</span>
        </div>
        <a class="login-link" (click)="login()" translate="cart.login"></a>
        <div class="no-account sign-up" *ngIf="!showBaoying && !displaySponsorDetails && !limitedShopping">
            <span translate="cart.noaccount.text"></span>&nbsp;
            <a class="navLink" (click)="sendUpsellPromotionClick()" [routerLink]="ENROLL_PC_INFO_ROUTE" translate="cart.sign.up"></a>
        </div>
    </div>
</div>
